import type { Language } from "@/utils/languageUtils";
import { dealerPortalLabels } from "@/i18n";

/**
 * PDF action cards for dealer portal vehicle card (same as prototype kontakt-kompass).
 */
export type VehiclePdfServiceType =
  | "glass"
  | "fullmakt"
  | "insurance"
  | "valuation"
  | "serviceschema"
  | "vdn";

export interface VehiclePdfActionCard {
  id: VehiclePdfServiceType;
  title: string;
  description: string;
  icon: string;
  color: string;
}

const CARD_CONFIG: Omit<VehiclePdfActionCard, "title" | "description">[] = [
  { id: "glass", icon: "🪟", color: "bg-blue-500/10 border-blue-500/30 hover:bg-blue-500/20" },
  { id: "fullmakt", icon: "📝", color: "bg-purple-500/10 border-purple-500/30 hover:bg-purple-500/20" },
  { id: "insurance", icon: "🛡️", color: "bg-green-500/10 border-green-500/30 hover:bg-green-500/20" },
  { id: "valuation", icon: "💰", color: "bg-rose-500/10 border-rose-500/30 hover:bg-rose-500/20" },
  { id: "serviceschema", icon: "📋", color: "bg-cyan-500/10 border-cyan-500/30 hover:bg-cyan-500/20" },
  { id: "vdn", icon: "📄", color: "bg-amber-500/10 border-amber-500/30 hover:bg-amber-500/20" },
];

/** Returns PDF action cards with i18n titles and descriptions. */
export function getVehiclePdfActionCards(lang?: Language): VehiclePdfActionCard[] {
  const labels = dealerPortalLabels(lang).pdfCards as Record<
    VehiclePdfServiceType,
    { title: string; description: string }
  >;
  return CARD_CONFIG.map((c) => ({
    ...c,
    title: labels[c.id]?.title ?? c.id,
    description: labels[c.id]?.description ?? "",
  }));
}
